define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AgeText = "Created";
    exports.NameText = "Name";
    exports.StatusText = "Status";
    exports.ConditionsText = "Conditions";
    exports.ImageText = "Image";
    exports.PodsDetailsText = "Pod";
    exports.StrategyText = "Strategy";
    exports.ReplicasCountText = "Pods #";
    exports.DeploymentsDetailsText = "Deployments";
    exports.ClusterIPText = "Cluster IP";
    exports.ExternalIPText = "External IP";
    exports.TypeText = "Type";
    exports.ReplicaSetText = "ReplicaSet";
    exports.PackageText = "Package";
    exports.PipelineText = "Pipeline";
    exports.PodsText = "Pods";
    exports.PodText = "Pod";
    exports.PortText = "Port";
    exports.NamespaceLabelText = "Namespace:";
    exports.PivotServiceText = "Services";
    exports.PivotWorkloadsText = "Workloads";
    exports.PodIP = "IP";
    exports.Created = "Created";
    exports.Deployment = "Deployment: {0}";
    exports.ReplicaSet = "ReplicaSet: {0}";
    exports.ServiceCreatedWithPipelineText = "Created {0} by {1}";
    exports.RunInformationForWorkload = "{0} on {1}";
    exports.OverviewText = "Overview";
    exports.LabelsText = "Labels";
    exports.SelectorText = "Selector";
    exports.SessionAffinityText = "Session affinity";
    exports.AssociatedPodsText = "Associated pods";
    exports.DaemonSetText = "DaemonSet";
    exports.StatefulSetText = "StatefulSet";
    exports.DeploymentText = "Deployment";
    exports.LearnMoreText = "Learn more";
    exports.NoPodsForSvcText = "This service currently does not map to any pods";
    exports.ExternalIPAllocPending = "External IP being allocated";
    exports.ExternalIPAllocated = "External IP available";
    exports.FindByNameText = "Filter by {0} name";
    exports.KindText = "Kind";
    exports.NoItemsText = "No Items found";
    exports.PodDetailsHeader = "Pod details";
    exports.JobText = "Job";
    exports.AnnotationsText = "Annotations";
    exports.RestartPolicyText = "Restart policy";
    exports.QoSClassText = "QoS class";
    exports.NodeText = "Node";
    exports.PodsListHeaderText = "Pods";
    exports.LogsText = "Logs";
    exports.YamlText = "YAML";
    exports.NoPodsFoundText = "No pods are detected in this Kubernetes workload";
    exports.LoadingText = "Loading...";
    exports.OtherWorkloadsText = "Other workloads";
    exports.CreatedAgo = "Created {0}";
    exports.ServiceDetails = "Service details";
    exports.WorkloadText = "Workload";
    exports.WorkloadDetails = "{0} details";
    exports.PodStatusPending = "Pending";
    exports.MoreImagesText = "{0} and {1} more";
    exports.LearnMoreKubeResourceText = "Learn more about Kubernetes resource";
    exports.DeployKubeResourceText = "Use this resource to deploy workloads and services";
    exports.StartUsingKubeResourceText = "Start using resource!";
    exports.KubernetesAuthValidationTitleText = "Validate to connect";
    exports.KubernetesAuthValidationHelpText = "The service account mapped to this resource doesn't have the necessary permissions to read workloads and services.";
    exports.KubernetesResourceDeletedAltText = "Unable to connect to the cluster and namespace";
    exports.KubernetesResourceDeletedHelpText = "Unable to connect to the cluster and namespace chosen for this resource. ";
    exports.StartingUsingServiceText = "You can also deploy services and track them in here";
    exports.DeployServices = "Deploy services!";
    exports.DeployWorkloads = "Deploy workloads!";
    exports.WorkloadsZeroDataText = "You can also deploy all kinds of workloads like deployment, replicaset, daemonset etc., and track them in here";
    exports.NoPodsForSvcLinkText = "Learn more about mapping a service";
    exports.NoPodsText = "No pods";
    exports.ServiceText = "service";
    exports.NoResultsFoundText = "No results found";
    exports.DigestText = "Digest";
    exports.TarIdText = "Tar ID";
    exports.ImageTypeText = "Image type";
    exports.MediaTypeText = "Media type";
    exports.RegistryText = "Registry";
    exports.ImageSizeText = "Image size";
    exports.ImageDetailsHeaderText = "Image details";
    exports.AllPodsRunningText = "All pods are running";
    exports.PodsNotReadyText = "{0} pods are not ready";
    exports.PodNotReadyText = "1 pod is not ready";
    exports.LayersText = "Layers";
    exports.CommandText = "Command";
    exports.SizeText = "Size";
    exports.SummaryHeaderSubTextFormat = "{0} (cluster)";
    exports.TagsText = "Tags";
    exports.LoadingPodsSpinnerLabel = "Loading associated pods...";
    exports.LoadingServicesSpinnerLabel = "Loading services...";
    exports.CopyExternalIp = "Copy External IP to clipboard";
    exports.CopiedExternalIp = "Copied!";
    exports.ImageDetailsUnavailableText = "Image details available only for images built in Azure Pipelines";
    exports.PodDetailsSubheader = "Pods in {0}";
    exports.ClusterLinkHelpText = "Navigation to cluster details is only available for the Azure provider";
});
